export default __webpack_public_path__ + "static/media/team-agnes.43854644.jpg";